import * as React from 'react';
import cx from 'classnames';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import TextInput from 'components/TextInput/TextInput';
import keyCodes from 'utils/keyCodes';
import styles from './OtpInput.css';
const OTP_PATTERN = /^[0-9]{1}$/;
const OTP_COUNT = 6;
export const FINAL_OTP_PATTERN = /^[0-9]{6}$/;
export default class OtpInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleOtpPaste = event => {
            if (!event) {
                return;
            }
            event.preventDefault();
            const { otpInputCount = OTP_COUNT, onChange } = this.props;
            const clipboardText = event.clipboardData || window.clipboardData;
            // Extract text from clipboardData.
            const pastedOTP = clipboardText && clipboardText.getData('text');
            // validate the otp by checking with the otp pattern.
            const validateOTP = pastedOTP && FINAL_OTP_PATTERN.test(pastedOTP);
            if (validateOTP) {
                const formattedOTP = pastedOTP.split('');
                // convert the otp string to array and move focus index to last field.
                this.setState({
                    otp: formattedOTP,
                    focusIndex: otpInputCount - 1
                }, () => {
                    if (typeof onChange === 'function') {
                        onChange(formattedOTP);
                    }
                });
            }
        };
        this.handleOtpChange = (value, id) => {
            const { onChange } = this.props;
            const { otp } = this.state;
            otp[id] = value;
            // skipOnChange would prevent advancing of cursor when onchange is fired through Backspace keydown method.
            if (this.skipOnChange) {
                this.setState({
                    otp
                }, () => {
                    if (typeof onChange === 'function') {
                        onChange(otp);
                    }
                });
                return;
            }
            // If it is not backspace advance the cursor.
            this.setState({
                otp,
                focusIndex: this.getFocusIndexBoundary(id + 1)
            }, () => {
                if (typeof onChange === 'function') {
                    onChange(otp);
                }
            });
        };
        this.getFocusIndexBoundary = (index) => {
            const { otpInputCount = OTP_COUNT } = this.props;
            const min = 0;
            const max = otpInputCount - 1;
            // Check whether the current Index is with in min and max boundaries, so as not to lose focus.
            if (index < min) {
                return min;
            }
            else if (index > max) {
                return max;
            }
            return index;
        };
        this.handleKeyDown = (id) => (e) => {
            const { otp } = this.state;
            const state = this.state;
            switch (e.keyCode) {
                case keyCodes.backspace:
                    // If there is any value in the current input box, first clear it and keep the foucsIndex as it is
                    // Else decrease the focusIndex.
                    this.skipOnChange = true;
                    if (otp[id] !== '' && typeof otp[id] !== 'undefined') {
                        otp[id] = ''; // Clearing the current value
                        Object.assign(state, {
                            otp,
                            focusIndex: this.getFocusIndexBoundary(id)
                        });
                        break;
                    }
                    Object.assign(state, {
                        otp,
                        focusIndex: this.getFocusIndexBoundary(id - 1)
                    });
                    break;
                case keyCodes.left:
                    // Decrease foucsIndex when arrowLeft is pressed.
                    Object.assign(state, {
                        focusIndex: this.getFocusIndexBoundary(id - 1)
                    });
                    break;
                case keyCodes.right:
                    // Increase foucsIndex when arrowRight is pressed.
                    Object.assign(state, {
                        focusIndex: this.getFocusIndexBoundary(id + 1)
                    });
                    break;
                default:
                    this.skipOnChange = false;
                    return;
            }
            this.setState(state);
        };
        this.state = {
            otp: props.defaultValue || [],
            focusIndex: 0
        };
        this.skipOnChange = false;
    }
    componentDidMount() {
        if (ExecutionEnvironment.canUseDOM) {
            // Add paste event handler to listen to otp paste events.
            document.addEventListener('paste', this.handleOtpPaste);
        }
    }
    componentWillUnmount() {
        // Remove the paste event handler on unmount.
        document.removeEventListener('paste', this.handleOtpPaste);
    }
    render() {
        const { otpInputCount = OTP_COUNT, inputContainerclass, inputClass, inputWrapperClass } = this.props;
        let otpInputs = [];
        for (let i = 0; i < otpInputCount; i++) {
            otpInputs.push(<TextInput maxLength={1} key={i} id={i} wrapperClass={cx(inputWrapperClass, styles['input-wrapper'])} className={cx(inputClass, styles['input'])} required={true} autoFocus={i === this.state.focusIndex} value={this.state.otp[i]} pattern={OTP_PATTERN} onKeyDown={this.handleKeyDown(i)} onTextChange={this.handleOtpChange}/>);
        }
        return <div className={cx(inputContainerclass, styles['input-container'])}>{otpInputs}</div>;
    }
}
